module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-foreword element-with-heading",
    attrs: {
      "epub:type": "foreword",
      "id": "foreword",
      "role": "doc-foreword"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_vm._v("THE OTHER BRIDGET")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "foreword-text"
    }
  }, [_c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-141"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "images/break-hedera-side-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("Once upon a time (briefly) Rachael Johns was an English teacher, then her dreams of becoming a novelist came true. Now she spends her days writing romance and women’s fiction in the Swan Valley, Western Australia. Her book "), _c('i', [_vm._v("The Patterson Girls")]), _vm._v(" won the ABIA Award in 2016 for General Fiction and she has won the prestigious Romance Writers of Australia RUBY Award twice. When she’s not writing, you’ll find Rachael reading, hanging with her adorable sheepadoodle, listening to audiobooks while cleaning up after her three teenage boys, or running the Rachael Johns’ Online Book Club on Facebook.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8aecceaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/the-other-bridget.vue
// module id = 72
// module chunks = 0